<div class='modal-backdrop'>
  <div class='modal-dialog'>
    <div class='modal-content'>
      <div class='modal-header'>
        @if (action) {
          <h4 class='modal-title'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.TITLE_VALIDATE' | translate }}</h4>
        }
        @if (!action) {
          <h4 class='modal-title'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.TITLE_REFUSE' | translate }}</h4>
        }
      </div>
      <form [formGroup]='profileRequestFormGroup' (ngSubmit)='onSubmitProfileRequestForm()' autocomplete='off' novalidate>
        <div class='form-horizontal form-label-left'>
          <div class='modal-body'>
            <div class='form-group'>

              @if (action) {
                <!-- REQUESTED START VALIDITY DATE -->
                <div class='form-group'>
                  <label class='control-label col-sm-5 col-md-5 col-xs-12 no-input'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.REQUESTED_START_VALIDITY_DATE' | translate }}</label>
                  <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.requestedStartValidityDate | date: 'dd/MM/yyyy' | noData }}</div>
                </div>
                <!-- BEGIN VALIDITY DATE -->
                <div class='form-group'>
                  <label class='control-label col-md-5 col-sm-5 col-xs-12 label-input-date' for='beginValidityDate'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.BEGIN_VALIDITY_DATE' | translate }}*</label>
                  <div class='col-md-7 col-sm-7 col-xs-12'>
                    <input matInput [min]='minDate' formControlName='beginValidityDate' id='beginValidityDate' maxlength='10' autocomplete='off' [matDatepicker]='beginValidityDate' class='form-control input-mat-datepicker'/>
                    <mat-datepicker-toggle matSuffix [for]='beginValidityDate'></mat-datepicker-toggle>
                    <mat-datepicker #beginValidityDate></mat-datepicker>
                    <ul class='parsley-errors-list filled'>
                      @if (beginDate.invalid && (beginDate.dirty || beginDate.touched)) {
                        <li class='parsley-required'>
                          @if (beginDate.errors.required) {
                            <div>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.BEGIN_DATE_MANDATORY' | translate }}</div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                <!-- END VALIDITY DATE -->
                <div class='form-group'>
                  <label class='control-label col-md-5 col-sm-5 col-xs-12 label-input-date' for='endValidityDate'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.END_VALIDITY_DATE' | translate }}</label>
                  <div class='col-md-7 col-sm-7 col-xs-12'>
                    <input matInput [min]='minDate' formControlName='endValidityDate' id='endValidityDate' maxlength='10' autocomplete='off' [matDatepicker]='endValidityDate' class='form-control input-mat-datepicker'/>
                    <mat-datepicker-toggle matSuffix [for]='endValidityDate'></mat-datepicker-toggle>
                    <mat-datepicker #endValidityDate></mat-datepicker>
                    <ul class='parsley-errors-list filled'>
                      @if (endDate.invalid && (endDate.dirty || endDate.touched)) {
                        <li class='parsley-required'>
                          @if (endDate.errors.greaterThan) {
                            <div>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.END_DATE_AFTER_BEGIN_DATE' | translate }}</div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }

              <!-- REQUEST PROFILE REASON STATUS -->
              <div class='form-group'>
                <label class='control-label col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.REASON_STATUS' | translate }}@if (!action) {
                  <span> *</span>
                }</label>
                <div class='col-sm-7 col-md-7 col-xs-12'>
                  <input type='text' id='reason' name='reason' class='form-control' formControlName='reasonStatus'/>
                  <ul class='parsley-errors-list filled'>
                    @if (reasonStatus.invalid && (reasonStatus.dirty || reasonStatus.touched)) {
                      <li class='parsley-required'>
                        @if (reasonStatus.errors.required) {
                          <div>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.REASON_STATUS_MANDATORY' | translate }}</div>
                        }
                      </li>
                    }
                  </ul>
                </div>
              </div>

              <!-- REQUEST PROFILE COMMENT -->
              <div class='form-group'>
                <label class='control-label col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.DIALOG.COMMENT' | translate }}</label>
                <div class='col-sm-7 col-md-7 col-xs-12'>
                  <textarea class='form-control' rows='3' formControlName='comment'>{{ profileRequest?.comment | noData }}</textarea>
                </div>
              </div>

            </div>
          </div>
          <div class='modal-footer'>
            <button [disabled]='profileRequestFormGroup.invalid' type='submit' class='btn btn-success pull-right'>{{ 'ACTIONS.CONFIRM' | translate }}</button>
            <button type='button' class='btn btn-danger pull-right' (click)='cancel()'>{{ 'ACTIONS.CANCEL' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
